<template>
  <PopupBox :popup-styles="{ top: 10, left: -10 }" placement="bottom-start" @visibility-change="handlePopupVisibilityChange">
  <template v-slot:trigger>
    <a href="#" class="user-bonuses-balance flex align-middle items-center" @click.prevent>
      <BalanceBonusIcon class="user-bonuses-balance-icon mr-2" />
      <span class="user-bonuses-balance-value">{{ hideBalance ? '_' : formatBalance(balance) }}</span>
      <PopupToggler :is-open="popupVisible" class="ml-2" />
    </a>
  </template>
  <template>
    <BonusBalanceContent
      :balance="balance"
      :bonus-system-details-link="bonusSystemDetailsLink"
      :hide-balance="hideBalance"
      @toggle-balance-visibility="$emit('toggle-balance-visibility', $event)"
    />
  </template>
  </PopupBox>
</template>

<script>
import BonusBalanceContent from '../bonus-balance-popup-content';
import { balanceFormatter } from '@/shared/lib/balance';
import { BalanceBonusIcon } from '@/shared/ui/icons';
import { PopupBox, popupToggle, PopupToggler } from '@/shared/ui/popup';

export default {
  props: {
    bonusSystemDetailsLink: {
      type: String,
      default: '',
      required: true,
    },
    balance: {
      type: Number,
      default: 0,
      required: false,
    },
    hideBalance: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [ balanceFormatter, popupToggle ],
  components: { BalanceBonusIcon, PopupBox, PopupToggler, BonusBalanceContent },
};
</script>

<style lang="scss" scoped>
.user-bonuses-balance {
  display: flex;
  align-items: center;
}

.user-bonuses-balance-value {
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  color: #09090B;
}
</style>
